import { createSelector } from 'reselect';

import * as lessonViewSelectors from 'common.components/lesson-view.store/selectors';
import * as lessonSelectors from 'common.components/lesson/selectors';
import { getIsPutOnBoardControlAvailable } from 'utils/lesson';
import { nowSelector } from 'utils/selectors/selectors';

export const getShouldShowOverlay = createSelector(
    [lessonSelectors.getLessonAssignmentDate, lessonViewSelectors.getShouldShowAssignmentSettings],
    (dateAssignment, shouldShowAssignmentSettings: boolean): boolean => {
        return Boolean(dateAssignment) && shouldShowAssignmentSettings;
    }
);

export const getIsPutOnBoardAvailable = createSelector(
    [lessonSelectors.getLesson, lessonSelectors.getLessonMeta, lessonSelectors.getIsLessonEvaluable, nowSelector],
    (
        lesson,
        lessonMeta,
        isEvaluable,
        now
        // eslint-disable-next-line max-params
    ): boolean => {
        if (!lessonMeta) {
            return true;
        }

        const hasLesson = Boolean(lesson?.id);
        const evaluationDate = lesson?.clesson?.evaluation_date;

        const lessonProps = {
            isEvaluable,
            evaluationDate: new Date(evaluationDate || 0),
            stream: lesson?.clesson?.stream || null,
        };

        return getIsPutOnBoardControlAvailable(hasLesson, lessonProps, lessonMeta, now);
    }
);
